import { render, staticRenderFns } from "./SectionAdmin.vue?vue&type=template&id=40046c5c"
import script from "./SectionAdmin.vue?vue&type=script&lang=js"
export * from "./SectionAdmin.vue?vue&type=script&lang=js"
import style0 from "./SectionAdmin.vue?vue&type=style&index=0&id=40046c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports